import { getToken } from './session';

const API_BASE = process.env.REACT_APP_API || 'http://localhost:4500/api';

async function authFetch(path, options = {}) {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `Request failed: ${res.status}`);
  }
  return res.json();
}

export const socialApi = {
  getProviders() {
    return authFetch('/social/providers');
  },
  mockConnect(provider) {
    return authFetch('/social/mock-connect', {
      method: 'POST',
      body: JSON.stringify({ provider }),
    });
  },
  publish({ provider, postId, title, content, imageUrl }) {
    return authFetch('/social/publish', {
      method: 'POST',
      body: JSON.stringify({ provider, postId, title, content, imageUrl }),
    });
  },
};

export const aiApi = {
  editPost(originalText, instructions) {
    return authFetch('/ai/edit-post', {
      method: 'POST',
      body: JSON.stringify({ originalText, instructions }),
    });
  },
};

